<template>
  <a-form-model
    :model="form"
    ref="form"
    :rules="rules"
    :label-col="{ span: 4 }"
    :wrapper-col="{ span: 20 }"
  >
    <a-form-model-item label="敏感词" prop="word">
      <a-input v-model="form.word" placeholder="请输入敏感词" />
    </a-form-model-item>

    <a-form-model-item :wrapper-col="{ span: 20, offset: 4 }">
      <a-button type="primary" @click="onSubmit">
        {{ formModel ? '修 改' : '创 建' }}
      </a-button>
      <a-button style="margin-left: 10px" @click="resetForm"> 重 置 </a-button>
    </a-form-model-item>
  </a-form-model>
</template>
<script>
import { addSensitiveApi, editSensitiveApi } from '@/api/System/Sensitive'
export default {
  data() {
    return {
      form: {
        word: ''
      },
      rules: {
        word: [{ required: true, message: '敏感词必填', trigger: ['change', 'blur'] }]
      },
      roleOptions: []
    }
  },

  props: ['formModel'],

  methods: {
    //修改敏感词：
    async updateUser() {
      const params = {
        word: this.form.word,
        id: this.form.id
      }
      const res = await editSensitiveApi(params)
      const { code, msg } = res
      if (code == '200') {
        this.$message.success(msg)
        this.$emit('refresh')
      } else {
        this.$message.error(msg)
      }
    },

    //添加敏感词：
    async createUser() {
      console.log(this.form)
      const res = await addSensitiveApi({ ...this.form })
      const { code, msg } = res
      if (code == '200') {
        this.$message.success(msg)
        this.$emit('refresh')
      } else {
        this.$message.error(msg)
      }
    },

    resetForm() {
      this.$refs.form.resetFields()
    },

    onSubmit() {
      this.$refs.form.validate(async (valid) => {
        if (valid) {
          if (this.formModel) {
            this.updateUser()
          } else {
            this.createUser()
          }
        }
      })
    }
  },

  watch: {
    formModel: {
      handler() {
        if (this.formModel) {
          Object.assign(this.form, this.formModel)
        }
      },
      immediate: true
    }
  }
}
</script>

<style lang="less" scoped></style>
